import { render } from "./AddUrlToEditorModalComponent.vue?vue&type=template&id=48df0092&ts=true"
import script from "./AddUrlToEditorModalComponent.vue?vue&type=script&lang=ts"
export * from "./AddUrlToEditorModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__